export const EMPLOYEES_INITIAL_CONTEXT = {
  employees: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  addEmployee: () => {},
  updateEmployee: () => {},
  handleDeleteEmployee: () => {},
  employeePositions: [],
  handlePageChange: () => {},
  currentPage: 1,
  setCurrentEmployeeId: () => {}
}
